import { Alert, Autocomplete, Box, Button, Card, CardActions, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Grid, InputLabel, MenuItem, Select, Stack, TextField, Typography } from '@mui/material';
import CardContent from '@mui/material/CardContent';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { addOrUpdateBuilding, deleteLocation, getLocationInfo } from '../../Data/ApiRequests';
import { Bezirke, IAuthResponse, ILocation, Kategorien, User, emptyLocation, sxfw } from '../../Interfaces';
import CheckIcon from '@mui/icons-material/Check';

import dayjs from 'dayjs';
import 'dayjs/locale/de';
import { GetHistoryLocation } from '../../Components/GetHistoryLocation/GetHistoryLocation';
import { RommspaceInfo } from '../../Components/RommspaceInfo/RommspaceInfo';
import { getUsers } from '../../Data/ApiUserRequests';
import FormControlLabel from '@mui/material/FormControlLabel';
import AddUserForm from '../../Components/AddUserForm/AddUserForm';


const LocationCard = () => {
    const navigate = useNavigate();

    //const bearerToken: IAuthResponse = useSelector((state: IAuthResponse) => state)
    const bearerToken: IAuthResponse = useSelector((state: IAuthResponse) => state)

    const { guid } = useParams();
    const pathlocation = useLocation();
    let isNewForm = false;
    const lastPath = pathlocation.pathname.split('/').filter(x=>x !== '').slice(-1)
    if (lastPath.length > 0 && lastPath[0] === 'new' )   isNewForm = true

    const [building, setBuilding] = useState<ILocation>(emptyLocation);
    const [operationResult, setOperationResult] = useState('');
    const [isErrorOnLoad, setIsErrorOnLoad] = useState(false)
    const [error, setError] = useState('');
    const [users, setUsers] = useState<User[]>([])


    const [isRemoveOpenDialog, setIsRemoveOpenDialog] = useState(false)
    const [errorTextOnSave, setErrorTextOnSave] = useState('');

    const [isAddNewUser, setIsAddNewUser] = useState(false)
    // Gets property from child
    const [newUserAdded, setNewUserAdded] = useState(0)
    const [workMode, setWorkMode] = useState('view');
    const [openDialog, setOpenDialog] = useState(false);
    const fetchData =  () => {
        if(isNewForm) {
            setBuilding(emptyLocation);
            return
        }
        getLocationInfo(guid, bearerToken.token)
            .then( response => {
                /* eslint-disable  @typescript-eslint/no-explicit-any */
                const jsonData:any = response; //ILocationWideResponse
                setBuilding(jsonData.location);
                console.log('location.userLocationPermissions', jsonData.location.userLocationPermissions)
                setError('');
                setIsErrorOnLoad(false)
            }).catch(error =>  {
            console.error('Error fetching data:', error);
                setError('Error fetching data:' + error)
                setIsErrorOnLoad(true)
            })
    };


    const loadUsers = async() => {
        getUsers(bearerToken.token)
            .then(response => {
                setUsers(response)
            }).catch( () => {
                setError('Error on fetching users')
            })
    }

    const handleChildClick = (value: number) => {
        setNewUserAdded(value)
      };

    useEffect(() => {
        if(newUserAdded === 0) fetchData();
        loadUsers();
    }, [newUserAdded]); // Empty dependency array ensures this effect runs only once on component mount


    const switchMode = (param: string) => {
        switch (param) {
            case 'view':
                setWorkMode('view')
                break;

            case 'edit':
                setWorkMode('edit')
                break;

                case 'remove':
                setWorkMode('remove')
                break;
        }
    }

    // console.log( Object.keys(building).join(' | '))

    const changeTextField = (key: string, newValue: string) => {
        const newBuilding = { ...building }
        if (key === 'name') newBuilding.name = newValue
        if (key === 'address') newBuilding.address = newValue
        if (key === 'district') newBuilding.district = newValue
        // if (key === 'capacity') newBuilding.capacity = parseInt(newValue)
        if (key === 'capacity')
        {
            newBuilding.capacity = (newValue.trim() === '' || parseInt(newValue.trim()) < 0) ? 0 : parseInt(newValue)
        }
        if (key === 'district') newBuilding.district = newValue
        if (key === 'contactPerson') newBuilding.contactPerson = newValue
        if (key === 'phoneNumber') newBuilding.phoneNumber = newValue
        if (key === 'email') newBuilding.email = newValue
        if (key === 'startOfOccupancy') newBuilding.startOfOccupancy = new Date(newValue)
        if (key === 'endOfOccupancy') newBuilding.endOfOccupancy = new Date(newValue)
        if (key === 'wnummer') newBuilding.wnummer = newValue

        if (key === 'locationCategory') newBuilding.locationCategory = newValue
        if (key === 'applicationUserId') newBuilding.applicationUserId = newValue.split(',').map((item: string) => item.trim())
        if (key === 'bl') newBuilding.bl = newValue
        if (key === 'tl') newBuilding.tl = newValue
        if (key === 'businessDivision') newBuilding.businessDivision = newValue


        setBuilding(newBuilding)
    }


    const SaveBuilding = async (): Promise<void> =>  {
         console.log('building', building)
        //if(!PreSave()) return;

        setOpenDialog(true)
        addOrUpdateBuilding( building, bearerToken.token)
            .then(response => {
                console.log('response', response)
                    setErrorTextOnSave('')
                    setOperationResult(response)
            }).catch ((error) => {
                console.log('error', error)
                    setOperationResult('')
                    setErrorTextOnSave(error)
                })
          };


    const preDeleteLocation = async (wnummer: string) => {
        setIsRemoveOpenDialog(true);
        setOperationResult(`Möchten Sie ${wnummer} wirklich löschen??`)
      }

      const confirmDeleteLocation = async (wnummer: string | undefined) => {
        if(wnummer === undefined) return;
        deleteLocation(wnummer , bearerToken.token)
          .then( response => {
            console.log(response)
            setOperationResult('Ort erfolgreich gelöscht')
            setTimeout(() => {
              setIsRemoveOpenDialog(false)
              navigate(`/locations/`)
            }, 1000);
        }).catch( error => console.log(error))
        setIsRemoveOpenDialog(true);
      }

    function setUkr(ischecked: string): void {
        console.log('event', ischecked)
        const prevBuilding = { ...building}
        const prevValue = prevBuilding.residentGroups;
        type typeIsCheckedRefugee = {
            Ukr: boolean,
            oRu: boolean,
        }

        const result: typeIsCheckedRefugee = {
            Ukr: (prevValue === 'All' || prevValue === 'Ukr') ? true : false,
            oRu: (prevValue === 'All' || prevValue === 'örU') ? true : false,
        }

        if(ischecked === 'Ukr') result.Ukr = !result.Ukr
        if(ischecked === 'örU') result.oRu = !result.oRu

        let strResult = ''
        if (result.Ukr && result.oRu) strResult = 'All'
        if (result.Ukr && !result.oRu) strResult = 'Ukr'
        if (!result.Ukr && result.oRu) strResult = 'örU'
console.log('strResult', strResult)
prevBuilding.residentGroups = strResult
console.log('prevBuilding', prevBuilding)

        setBuilding(prevBuilding)
    }

    return (
        <>
        {
            !bearerToken.isLoggedIn && <h2>Sie sind nicht befugt</h2>
        }



<label >{error}</label>
{


    (bearerToken.isLoggedIn && !isErrorOnLoad) &&
<div>

        {
            isNewForm && <h2>Neuen Standort hinzufügen</h2>
        }
        {
            !isNewForm && <h2>Standort</h2>
        }



            <Card sx={{p: 0, m: 0}}>
                {
                    (!isNewForm && workMode !== 'edit') &&
                    <CardActions sx={{p: 1, m: 1}}>
                        <Box display="flex" justifyContent="flex-start" sx={{width: '100%',  my: '0', p: '0'}} >


                                {
                                    bearerToken.role === 'Admin' &&
                                    <>
                                    <Button  variant='contained' color='warning' onClick={() => {
                                        if (building.wnummer !== undefined) preDeleteLocation(building.wnummer)
                                    }}>Löschen</Button>

                                    <Box my={0.3} p={0.3} /><Button variant="contained" onClick={() => { switchMode('edit') }} color='info' >Bearbeiten </Button>
                                        </>
                                }
                                <Box my={0.3} p={0.3} />
                                     <Button variant="contained" sx={{mx: '1'}} onClick={() => { navigate('/freespace/' + building.wnummer) }}  color='secondary'>Neue Freiplatzmeldung</Button>
                                </Box>
                </CardActions>
                }
                <CardContent style={{ width: '100%', padding: 0, margin: 0}}>
                {
                    (workMode !== 'edit' && !isNewForm) &&
                    <>

                    <Box sx={sxfw}>
                    <Typography sx={{ fontSize: 14 }}  gutterBottom>Leitzeichen / W-Nummer: {building.wnummer}</Typography>
                    <Typography sx={{ fontSize: 14 }}  gutterBottom>Name: {building.name}</Typography>
                    <Typography sx={{ fontSize: 14 }} gutterBottom>Kategorie: {building.locationCategory}</Typography>
                    <Typography sx={{ fontSize: 14 }} gutterBottom>Bezirk: {building.district}</Typography>
                    <Typography sx={{ fontSize: 14 }}  gutterBottom>Adresse: {building.address}</Typography>
                    <Typography sx={{ fontSize: 14 }}  gutterBottom>Ansprechpartner: {building.contactPerson}</Typography>
                    <Typography sx={{ fontSize: 14 }}  gutterBottom>Telefon: {building.phoneNumber}</Typography>
                    <Typography sx={{ fontSize: 14 }}  gutterBottom>Email: {building.email}</Typography>
                    <Typography sx={{ fontSize: 14 }}  gutterBottom>Soll-Kapazität: {building.capacity}</Typography>
                    </Box>
                {
                    building.wnummer!== undefined &&
                    <>
                    <RommspaceInfo isHistory={false} wnummer={building.wnummer} />
                    <GetHistoryLocation wnummer={building.wnummer}  />
                    </>
                }

                    </>
                }
                    {
                        (workMode === 'edit' || isNewForm ) &&

                        <CardContent  title='Edit mode' >
                            <Grid container >
                                <Grid item xs={12} sm={6} md={4}>
                                        <Box sx={sxfw}>
                                            <TextField id="Name" label="Name" required variant="outlined" value={building.name} size='small' sx={{ width: '250px' }}
                                                onChange={(evt) => { changeTextField('name', evt.target.value) }} />
                                        </Box>
                                        <Box sx={sxfw}>
                                            <TextField id="Wnummer" label="Wnummer" required variant="outlined" value={building.wnummer} size='small' sx={{ width: '250px' }}
                                                onChange={(evt) => { changeTextField('wnummer', evt.target.value) }} />
                                        </Box>
                                        <Box sx={sxfw}>
                                            <FormControl sx={{ width: '250px', padding: '0px 0px' }} size="small">
                                                <InputLabel id="kategorie-label" sx={{ background: 'white' }} >Kategorie</InputLabel>
                                                <Select value={building.locationCategory} labelId="Kategorie" id="Kategorie"
                                                    onChange={(event) => {
                                                        changeTextField('locationCategory', event.target.value)
                                                    }}>
                                                    {
                                                        Kategorien.map((option, index) => (
                                                            <MenuItem key={`K${index}`} value={option} selected={building.locationCategory === option}>{option}</MenuItem>
                                                        ))
                                                    }
                                                </Select>
                                            </FormControl>
                                        </Box>

                                        <Box sx={sxfw}>
                                            <FormControl sx={{ width: '250px', padding: '0px 0px' }} size="small">
                                                <InputLabel id="Bezirk-label" sx={{ background: 'white' }} >Bezirk</InputLabel>
                                                <Select value={building.district} labelId="Bezirk" id="Bezirk" size='small' sx={{ minWidth: 150 }}
                                                    onChange={(event) => {
                                                        changeTextField('district', event.target.value)
                                                    }}>
                                                    {
                                                        Bezirke.map((option, index) => (
                                                            <MenuItem key={`d${index}`} value={option} selected={building.district === option}>{option}</MenuItem>
                                                        ))
                                                    }
                                                </Select></FormControl>
                                        </Box>
                                        <Box sx={sxfw}>
                                            <TextField id="Addresse" label="Adresse" variant="outlined" value={building.address} size='small' sx={{ width: '250px' }}
                                                onChange={(evt) => { changeTextField('address', evt.target.value) }} />
                                        </Box>


                                        <Box sx={sxfw}>
                                            <TextField id="SollCapacity" label="Soll-Kapazität" variant="outlined" value={building.capacity}
                                                type="text" size='small' sx={{ width: '250px' }}
                                                onChange={(evt) => { changeTextField('capacity', evt.target.value) }} />
                                        </Box>

                                        <Box sx={sxfw}>
                                            <FormControl sx={{ width: '250px', padding: '0px 0px' }} size="small">
                                                {/* <InputLabel id="User-label" sx={{ background: 'white' }} >User</InputLabel> */}
                                                <Autocomplete
    multiple
    options={users} 
    getOptionLabel={(option) => option.fullName || ''}
                    // value={users.filter(user =>
                    //     (building.userLocationPermissions || []).some(p => p === user.id)
                    // )}
                value={users.filter(u=> (building.userLocationPermissions??[]).some(x=>x.userId === u.id)) }
    
    
    onChange={(event, newValue) => {
        const selectedIds = newValue.map(user => user.id).filter((id): id is string => typeof id === 'string');
        const newBuilding = {...building}
        newBuilding.applicationUserId = selectedIds
        newBuilding.userLocationPermissions = selectedIds.map(id => ({
            userId: id,
            permissionLevel: '', // Default permission level, adjust as needed
            wnummer: building.wnummer
        }));
        console.log('newBuilding.applicationUserId', newBuilding.applicationUserId)
        setBuilding(newBuilding)
    }}
    renderInput={(params) => (
        <TextField {...params} label="User" variant="outlined" size="small" InputLabelProps={{ shrink: true}} />
    )}
    sx={{ width: 250 }} />
                                                {/* // <Select value={building.applicationUserId || []} 
                                                //         multiple={true} multiline={true}
                                                //         labelId="User" id="User" size='small' sx={{ minWidth: 150 }}
                                                //         onChange={(event) => {
                                                //             console.log('event.target.value', event.target.value)
                                                //             // changeTextField('applicationUserId', event.target.value)
                                                //             const newBuilding = {...building}
                                                //             newBuilding.applicationUserId = event.target.value as string[];
                                                //             setBuilding(newBuilding)
                                                //     }}
                                                //         renderValue={(selected) =>
                                                //             users
                                                //                 .filter(user => selected.includes(user.id || ''))
                                                //                 .map(user => user.fullName)
                                                //                 .join(', ')
                                                //         }
                                                //     >
                                                //     {
                                                //         users.map((option, index) => (
                                                //             <MenuItem key={`d${index}`} value={option.id}
                                                //             >{option.fullName}</MenuItem>
                                                //         ))
                                                //     }
                                                // </Select>  */}
                                            </FormControl>
                                        </Box>
                                        <Box sx={sxfw}>

                                                {/* <Link to='/usermanager'>Neuen Nutzer hinzufügen</Link> */}
                                                <Button onClick={() => { setIsAddNewUser(true) }} variant='outlined'>Neuen Nutzer hinzufügen</Button>
                                                </Box>


                                </Grid>
                                <Grid item xs={12} sm={6} md={4}>

                                        <Box sx={sxfw}>
                                            <TextField id="Ansprechpartner" label="Ansprechpartner" variant="outlined" value={building.contactPerson}
                                                size='small' sx={{ width: '250px' }}
                                                onChange={(evt) => { changeTextField('contactPerson', evt.target.value) }} />
                                        </Box>

                                        <Box sx={sxfw}>
                                            <TextField id="Telefon" label="Telefon" variant="outlined" value={building.phoneNumber} type="text"
                                                size='small' sx={{ width: '250px' }}
                                                onChange={(evt) => { changeTextField('phoneNumber', evt.target.value) }} />
                                        </Box>
                                        <Box sx={sxfw}>
                                            <TextField id="Email" label="Email" variant="outlined" value={building.email}
                                                size='small' sx={{ width: '250px' }}
                                                onChange={(evt) => { changeTextField('email', evt.target.value) }} />
                                        </Box>

                                        <Box sx={sxfw}>
                                            <TextField id="BusinessDivision" label="Geschäftsbereich" variant="outlined" value={building.businessDivision}
                                                size='small' sx={{ width: '250px' }}
                                                onChange={(evt) => { changeTextField('businessDivision', evt.target.value) }} />
                                        </Box>

                                        <Box sx={sxfw}>
                                            <TextField id="BL" label="BL" variant="outlined" value={building.bl}
                                                size='small' sx={{ width: '250px' }}
                                                onChange={(evt) => { changeTextField('bl', evt.target.value) }} />
                                        </Box>
                                        <Box sx={sxfw}>
                                            <TextField id="BL" label="TL" variant="outlined" value={building.tl}
                                                size='small' sx={{ width: '250px' }}
                                                onChange={(evt) => { changeTextField('tl', evt.target.value) }} />
                                        </Box>

                                        <Box sx={sxfw}>
                                        <label>Bewohnergruppen</label>:<br />
                                            <FormControlLabel control={<Checkbox
                                                checked={ (building.residentGroups === 'All' || building.residentGroups === 'Ukr') }
                                                onChange={ () => setUkr('Ukr') } />} label="Ukr" />
                                            <FormControlLabel control={<Checkbox
                                            checked={ (building.residentGroups === 'All' || building.residentGroups === 'örU') }
                                            onChange={ () => setUkr('örU') }
                                            />} label="örU" />


                                        </Box>
                                </Grid>

                            </Grid>








                <Box sx={sxfw}>
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="de">
                    <Box sx={{ mv: 1, mh: 0, pv: 1, ph: 0 }}>
                        <DatePicker sx={{ width: '250px' }} label='Belegungsstart'
                            views={['year', 'month', 'day']}
                            value={ (building.startOfOccupancy !== null) ? dayjs(building.startOfOccupancy?.toString()) : null}
                            /// value={building.startOfOccupancy}
                            slotProps={{
                                textField: {
                                  required: true,
                                },
                              }}
                            onChange={(evt) => {
                                if (evt?.isValid()) {
                                    const dat = (evt !== null) ? evt?.toISOString().substring(0, 10) : '';
                                    console.log('dat', dat )
                                    changeTextField('startOfOccupancy', dat)
                                }
                                if(evt === undefined) {
                                    console.log('onChange', evt)
                                    // changeTextField('startOfOccupancy', ''  )
                                }
                            }}
                        />
                    </Box>
                    <Box sx={{ mt: 1, pt: 1 }}>
                        <DatePicker sx={{ width: '250px' }} label='Belegungsende'
                            views={['year', 'month', 'day']}
                            value={ (building.endOfOccupancy !== null) ? dayjs(building.endOfOccupancy?.toString()) : null}
                            slotProps={{
                                textField: {
                                  required: true,
                                },
                              }}
                            onChange={(evt) => {

                                console.log('evr', evt)
                                if (evt?.isValid()) {
                                    const dat = (evt !== null) ? evt?.toISOString().substring(0, 10) : '';
                                    changeTextField('endOfOccupancy', dat)
                                }
                            }}
                        /></Box>
                            </LocalizationProvider>
                </Box>
                <Stack spacing={1} direction="row">
                                    <Button variant="contained" onClick={() => {
                                        fetchData();
                                        navigate('/')
                                    }}>Abbrechen</Button>&nbsp;

                                    <Button variant="contained" onClick={() => SaveBuilding()}>Speichern</Button>
                                </Stack>
                                </CardContent>

                    }
                </CardContent>

            </Card>


            <Dialog open={openDialog}> {/* Operation result */}
                <DialogTitle>Operation result</DialogTitle>
                <DialogContent>
                    {
                        errorTextOnSave === '' &&
                        <Alert icon={<CheckIcon fontSize="inherit" />} severity="success">
                            {`${operationResult}`}
                            </Alert>
                    }

                    {
                        errorTextOnSave !== '' &&
                        <Alert icon={<CheckIcon fontSize="inherit" />} severity="error">
                            {`${errorTextOnSave}`}
                            </Alert>
                    }
                </DialogContent>
                <DialogActions>

                    <Button onClick={() => {
                        setOpenDialog(false);
                        if(errorTextOnSave === '') {
                            navigate(`/locations/`);
                        }
                        setErrorTextOnSave('')
                        setOperationResult('')
                    }}>Schliessen</Button>
                </DialogActions>

            </Dialog>


            <Dialog open={isRemoveOpenDialog}>
            <DialogTitle></DialogTitle>
            <DialogContent>

              <Alert severity={errorTextOnSave !== '' ? 'error' : 'success' } >

                {errorTextOnSave !== '' ?  errorTextOnSave : operationResult  }
              </Alert>
            </DialogContent>
            <DialogActions>
              <Button onClick={ ()=> setIsRemoveOpenDialog(false) } color="primary">
                Schliessen
              </Button>
              <Button onClick={() => confirmDeleteLocation(building.wnummer)} color="secondary">
                Löschen
              </Button>
            </DialogActions>
        </Dialog>

        <Dialog open={isAddNewUser}>
            <DialogContent>

                < AddUserForm setIsNewUserAdded={handleChildClick} />
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setIsAddNewUser(false)} color="primary">
                    Schliessen
                </Button>

            </DialogActions>
        </Dialog>
</div>
}
        </>

    );
};

export default LocationCard;

